export default {
  zh: {
    dear: 'Dear user',
    welcome:
      'Welcome to the Host System, through which you can receive corresponding cash rewards. The rules are as follows:',
    ruleContent: `
    1: In order to activate a host agency, the number of hosts to be registered must be no less than 15 hosts ( The number can be more, but it cannot be less ) <br/>
    2: Money is earned by receiving Rubies gifts<br>
    3: the ruby ​​gifts result in diamonds that can be exchanged for coins.  The host can also withdraw rubies from his points to use them in the ruby ​​wallet, and this has an impact on his points<br/>
    4: The Target is completed at the end of each month and the beginning of a new Target with a new month, the money is sent to the agencies on the 10th of each month<br/>
    5: The host agencies are received via App WhatsApp to send all the information required for registration at the beginning of each month`,
    desc1:
      'Cash rewards will be canceled for the following accounts: refunds after recharging, and cheating by one user using multiple fake accounts',
    desc2: '',
    tips: 'Notice',
    wait: 'Pending review',
    waitc: 'Please be patient and follow the application progress at any time',
    suc: 'Successful application',
    sucC: 'Congratulations on becoming a member of the host system program. You will be able to withdraw rubies.',
    fail: 'Application failed',
    failC: 'We are very sorry that your host system application failed for the following reasons:',

    apply: 'Apply',
    rapply: 'Re-apply',
    whatsapp: 'Whatsapp', //me
    areaNumber: 'area number: +44', //me
    phomeNumber: 'phome number: 7707115144', //me,
    welcomeText:`Welcom to`,
    hostsystem:"Host System",
    findanAgency:"Find an Agency",
    createanAgency:"Create an Agency",
    findText:"Find and apply to join a Agency to become a Host",
    craeteText:"Apply to create an Agency and invite others to join",
  },
  en: {
    dear: 'Dear user',
    welcome:
      'Welcome to the Host System, through which you can receive corresponding cash rewards. The rules are as follows:',
    ruleContent: `
    1: In order to activate a host agency, the number of hosts to be registered must be no less than 15 hosts ( The number can be more, but it cannot be less ) <br/>
    2: Money is earned by receiving Rubies gifts<br>
    3: the ruby ​​gifts result in diamonds that can be exchanged for coins.  The host can also withdraw rubies from his points to use them in the ruby ​​wallet, and this has an impact on his points<br/>
    4: The Target is completed at the end of each month and the beginning of a new Target with a new month, the money is sent to the agencies on the 10th of each month<br/>
    5: The host agencies are received via App WhatsApp to send all the information required for registration at the beginning of each month`,
    desc1:
      'Cash rewards will be canceled for the following accounts: refunds after recharging, and cheating by one user using multiple fake accounts',
    desc2: '',
    tips: 'Notice',
    wait: 'Pending review',
    waitc: 'Please be patient and follow the application progress at any time',
    suc: 'Successful application',
    sucC: 'Congratulations on becoming a member of the host system program. You will be able to withdraw rubies.',
    fail: 'Application failed',
    failC: 'We are very sorry that your host system application failed for the following reasons:',

    apply: 'Apply',
    rapply: 'Re-apply',
    whatsapp: 'Whatsapp', //me
    areaNumber: 'area number: +44', //me
    phomeNumber: 'phome number: 7707115144', //me,
    welcomeText:`Welcom to`,
    hostsystem:"Host System",
    findanAgency:"Find an Agency",
    createanAgency:"Create an Agency",
    findText:"Find and apply to join a Agency to become a Host",
    craeteText:"Apply to create an Agency and invite others to join",
  },
  ar: {
    dear: 'عزيزي المستخدم',
    welcome:
      'مرحبا بكم في الانضمام إلى النظام المضيف، من خلال النظام المضيف، يمكنك الحصول على المكافآت النقدية المقابلة، والقواعد هي كما يلي',
    ruleContent: `1: لتفعيل وكالة مضيفين يجب أن لا يقل عدد المضيفين المراد تسجيلهم عن 15 مضيف ( يمكن أن يكون العدد أكثر ولا يمكن أن يكون أقل )<br/>
    2: يتم ترقية التارجت عن طريق تلقي هدايا الياقوت فقط<br/>
    3: هدايا الياقوت ينتج عنها ألماس يمكن استبدالها بكونزات.  كما يستطيع المضيف سحب الياقوت من نقاط التارجت ليستخدمها في محفظة الياقوت وهذا له تأثير على نقاطه<br/>
    4: يتم توقيف ترقية التارجت في نهاية كل شهر وبداية تارجت جديد مع الشهر الجديد ، و يتم إرسال الأموال إلى الوكالات في  10  من كل شهر<br/>
    5: يتم استقبال الوكالات المضيفة عبر WhatsApp لإرسال كافة المعلومات المطلوبة للتسجيل في بداية كل شهر`,
    desc1:
      'سيتم إلغاء المكافآت النقدية للحسابات التالية: استرداد بعد إعادة الشحن، مستخدم واحد باستخدام حسابات مزيفة متعددة للغش',
    desc2: '',
    tips: 'ملاحظة',
    wait: 'في انتظار مراجعة',
    waitc: 'يرجى الانتظار بصبر، يمكنك اتباع تقدم التطبيق',
    suc: 'تطبيق ناجح',
    sucC: 'تهانينا لأنك أصبحت عضوًا في برنامج النظام المضيف. ستتمكن من سحب الياقوت.',
    fail: 'فشل التطبيق',
    failC: 'أنا آسف جدًا لفشل تطبيق نظام المضيف ، والسبب:',

    apply: 'تطبيق',
    rapply: 'أعد التطبيق',
    whatsapp: 'Whatsapp', //me
    areaNumber: 'رمز الدولة CN:+44', //me
    phomeNumber: 'جوال :7707115144',
    welcomeText:`مرحبا بكم في`,
    hostsystem:" نظام المضيف",
    findanAgency:"ابحث عن وكالة",
    createanAgency:"إنشاء وكالة",
    findText:"ابحث وتقدم للانضمام إلى وكالة لتصبح مضيفا",
    craeteText:"تقدم بطلب لإنشاء وكالة ودعوة الآخرين للانضمام",
  },
  tr: {
    dear: 'Karşılıklı nakit ödüller alabileceğiniz Ajans Sistemine hoş geldiniz. ',
    welcome: 'Kurallar şunlardır:',
    ruleContent: `
    1. Ajans etkinleştirmek için, Kayıt edilecek yayıncı sayısı 15  kişiden az olmamalıdır (Sayı daha fazla olabilir, daha az olamaz)<br/>
2: Para Yakut hediyeleri alarak kazanılır<br/>
3: Yakut hediyeler paralarla değiştirilebilir ve coinse dönüştürülebilir Bu durum kotayı etkilemeyecektir. yayıncılar ayrıca yakutları  %50 olarak Dönüştürebilir ama bu kotadan düşürülecektir.<br/>
4: Kota her ayın sonunda tamamlanır ve yeni bir ay ile yeni bir Kota başlangıcında, Para, her ayın 10'unda ajanslara gönderilir.<br/>
5: Ajans sahipleri, her ayın başında yeni kayıt için gerekli id’leri göndermek için App WhatsApp ve yönetim  ekibi üzerinden alınır.<br/>
    `,
    desc1:
      'Nakit ödüller aşağıdaki hesaplar için iptal edilecektir: <br/>    - Çekim yaptıktan sonra geri İade alınması,<br/>    - Birden fazla sahte hesap kullanarak bir kullanıcı tarafından hile yapılması.',
    desc2: '',
    tips: 'Farkına varmak',
    wait: 'İnceleme bekleniyor',
    waitc: 'Lütfen sabırlı olun ve başvurunun ilerlemesini istediğiniz zaman takip edin',
    suc: 'Başarılı uygulama',
    sucC: 'Ana bilgisayar sistemi programına üye olduğunuz için tebrikler. Yakutları geri çekebileceksiniz.',
    fail: 'Uygulama başarısız oldu',
    failC: 'Ana bilgisayar sistemi uygulamanız aşağıdaki nedenlerden dolayı başarısız olduğu için çok üzgünüz:',

    apply: 'Uygulamak',
    rapply: 'Yeniden başvur',
    whatsapp: 'Whatsapp', //me
    areaNumber: ' +44', //me
    phomeNumber: 'Telefon numarası:7707115144', //me
    welcomeText:`Ajans Sistemine`,
    hostsystem:"Hoşgeldiniz",
    findanAgency:"Bir Ajans Bul",
    createanAgency:"Bir Ajans Oluşturun",
    findText:"Yayıncı olmak için bir ajansa başvurun",
    craeteText:"Bir Ajans oluşturmak için başvurun ve başkalarını katılmaya davet edin",
  },
  pt: {
    dear: "Caro usuário",
    welcome: "Bem-vindo ao Sistema de Hosts, através do qual você pode receber recompensas em dinheiro. As regras são as seguintes:",
    ruleContent: `
    1: Para ativar uma agência de host, o número de hosts a serem registrados deve ser no mínimo 15 hosts (o número pode ser maior, mas não pode ser menor) <br/>
    2: O dinheiro é ganho ao receber presentes de Rubis<br/>
    3: Os presentes de rubis resultam em diamantes que podem ser trocados por moedas. O host também pode retirar rubis de seus pontos para usá-los na carteira de rubis, o que afeta seus pontos<br/>
    4: O objetivo é concluído no final de cada mês e o início de um novo objetivo com o novo mês, o dinheiro é enviado para as agências no dia 10 de cada mês<br/>
    5: As agências de host recebem via WhatsApp do aplicativo para enviar todas as informações necessárias para o registro no início de cada mês`,
    desc1: "As recompensas em dinheiro serão canceladas para as seguintes contas: reembolsos após recarga e trapaça por um usuário utilizando várias contas falsas",
    desc2: "",
    tips: "Aviso",
    wait: "Aguardando revisão",
    waitc: "Por favor, seja paciente e acompanhe o progresso da aplicação a qualquer momento",
    suc: "Aplicação bem-sucedida",
    sucC: "Parabéns por se tornar um membro do programa do sistema de hosts. Você poderá retirar rubis.",
    fail: "Falha na aplicação",
    failC: "Lamentamos muito que sua aplicação ao sistema de hosts tenha falhado pelos seguintes motivos:",
    apply: "Aplicar",
    rapply: "Reaplicar",
    whatsapp: "Whatsapp",
    areaNumber: "número da área: +44",
    phomeNumber: "número de telefone: 7707115144",
    welcomeText: "Bem-vindo a",
    hostsystem: "Sistema de Hosts",
    findanAgency: "Encontrar uma Agência",
    createanAgency: "Criar uma Agência",
    findText: "Encontre e se inscreva para ingressar em uma Agência para se tornar um Host",
    craeteText: "Inscreva-se para criar uma Agência e convidar outros para se juntarem"
  },
  id: {
    dear: "Pengguna yang terhormat",
    welcome: "Selamat datang di Sistem Host, melalui mana Anda dapat menerima hadiah uang tunai. Aturan adalah sebagai berikut:",
    ruleContent: `
    1: Untuk mengaktifkan agen host, jumlah host yang akan didaftarkan harus minimal 15 host (jumlah bisa lebih banyak, tapi tidak bisa lebih sedikit) <br/>
    2: Uang diperoleh dengan menerima hadiah Rubi<br/>
    3: Hadiah rubi menghasilkan berlian yang dapat ditukar dengan koin. Host juga dapat menarik rubi dari poin mereka untuk menggunakannya di dompet rubi, yang berdampak pada poin mereka<br/>
    4: Target diselesaikan pada akhir setiap bulan dan awal target baru dengan bulan baru, uang dikirim ke agen pada tanggal 10 setiap bulan<br/>
    5: Agen host menerima melalui WhatsApp aplikasi untuk mengirimkan semua informasi yang diperlukan untuk pendaftaran pada awal setiap bulan`,
    desc1: "Hadiah uang tunai akan dibatalkan untuk akun-akun berikut: pengembalian dana setelah pengisian ulang, dan kecurangan dengan satu pengguna menggunakan beberapa akun palsu",
    desc2: "",
    tips: "Pemberitahuan",
    wait: "Menunggu ulasan",
    waitc: "Harap bersabar dan ikuti kemajuan aplikasi kapan saja",
    suc: "Aplikasi berhasil",
    sucC: "Selamat telah menjadi anggota program sistem host. Anda dapat menarik rubi.",
    fail: "Aplikasi gagal",
    failC: "Kami sangat menyesal aplikasi sistem host Anda gagal karena alasan berikut:",
    apply: "Lamar",
    rapply: "Lamar ulang",
    whatsapp: "Whatsapp",
    areaNumber: "nomor area: +44",
    phomeNumber: "nomor telepon: 7707115144",
    welcomeText: "Selamat datang di",
    hostsystem: "Sistem Host",
    findanAgency: "Cari Agen",
    createanAgency: "Buat Agen",
    findText: "Cari dan lamar untuk bergabung dengan Agen untuk menjadi Host",
    craeteText: "Lamar untuk membuat Agen dan mengundang orang lain untuk bergabung"
  },
  uz: {
    dear: "Hurmatli foydalanuvchi",
    welcome: "Host tizimiga xush kelibsiz, bu orqali siz tegishli pul mukofotlarini olishishingiz mumkin. Qoidalar quyidagicha:",
    ruleContent: `
    1: Host agentligini faollashtirish uchun ro'yxatdan o'tkaziladigan hostlar soni kamida 15 host bo'lishi kerak (soni ko'proq bo'lishi mumkin, lekin kam bo'lmasligi kerak) <br/>
    2: Pul Rubi sovg'alarini qabul qilish orqali topiladi<br/>
    3: Rubi sovg'alari diamonddan hosil bo'ladi, ular tanga bilan almashiniladi. Host, shuningdek, o'zining nuqtalaridan rubilarni olib, ularni rubi hamyonida ishlatishi mumkin, bu uning nuqtalariga ta'sir qiladi<br/>
    4: Har bir oyning oxirida maqsad bajariladi va yangi oyda yangi maqsad boshlanadi, pul har oyning 10-sida agentlarga yuboriladi<br/>
    5: Host agentliklari, har oy boshida ro'yxatdan o'tish uchun barcha kerakli ma'lumotlarni yuborish uchun WhatsApp orqali App orqali olinadi`,
    desc1: "Pul mukofotlari quyidagi hisoblar uchun bekor qilinadi: qaytarib olishdan so'ng va bir foydalanuvchi bir nechta soxta hisoblardan foydalanib aldash",
    desc2: "",
    tips: "Ogohlantirish",
    wait: "Ko'rib chiqish kutilyapti",
    waitc: "Iltimos, sabrli bo'ling va ilovalar jarayonini har doim kuzatib boring",
    suc: "Muvaffaqiyatli ariza",
    sucC: "Host tizimi dasturiga a'zo bo'lganingiz uchun tabriklaymiz. Siz rubilardan pul olib ketishingiz mumkin.",
    fail: "Ariza muvaffaqiyatsiz",
    failC: "Afsuski, sizning host tizimi arizangiz quyidagi sabablarga ko'ra muvaffaqiyatsiz bo'ldi:",
    apply: "Ariza berish",
    rapply: "Qayta ariza berish",
    whatsapp: "Whatsapp",
    areaNumber: "hudud raqami: +44",
    phomeNumber: "telefon raqami: 7707115144",
    welcomeText: "Xush kelibsiz",
    hostsystem: "Host tizimi",
    findanAgency: "Agentlikni topish",
    createanAgency: "Agentlik yaratish",
    findText: "Host bo'lish uchun agentlikka qo'shilish uchun toping va ariza bering",
    craeteText: "Agentlik yaratish uchun ariza bering va boshqalarni qo'shishga taklif qiling"
  },
  ru: {
    dear: "Уважаемый пользователь",
    welcome: "Добро пожаловать в систему хостов, через которую вы можете получать соответствующие денежные вознаграждения. Правила следующие:",
    ruleContent: `
    1: Чтобы активировать агентство хостов, количество хостов, которых необходимо зарегистрировать, должно быть не менее 15 хостов (можно больше, но не меньше) <br/>
    2: Деньги зарабатываются при получении подарков рубинов<br/>
    3: Подарки рубинов приводят к алмазам, которые можно обменять на монеты. Хост также может выводить рубины из своих баллов и использовать их в кошельке рубинов, что влияет на его баллы<br/>
    4: Цель выполняется в конце каждого месяца, и начинается новый месяц с новой целью, деньги отправляются агентствам 10 числа каждого месяца<br/>
    5: Агентства хостов получают информацию через WhatsApp приложения для отправки всех данных, необходимых для регистрации в начале каждого месяца`,
    desc1: "Денежные вознаграждения будут отменены для следующих аккаунтов: возврат средств после пополнения и мошенничество, когда один пользователь использует несколько поддельных аккаунтов",
    desc2: "",
    tips: "Уведомление",
    wait: "Ожидает проверки",
    waitc: "Пожалуйста, подождите и следите за процессом заявки в любое время",
    suc: "Успешная заявка",
    sucC: "Поздравляем с тем, что вы стали членом программы системы хостов. Вы сможете вывести рубины.",
    fail: "Заявка не удалась",
    failC: "Очень жаль, но ваша заявка в систему хостов не удалась по следующим причинам:",
    apply: "Подать заявку",
    rapply: "Подать заявку повторно",
    whatsapp: "Whatsapp",
    areaNumber: "код региона: +44",
    phomeNumber: "номер телефона: 7707115144",
    welcomeText: "Добро пожаловать в",
    hostsystem: "Система хостов",
    findanAgency: "Найти агентство",
    createanAgency: "Создать агентство",
    findText: "Найдите и подайте заявку на вступление в агентство, чтобы стать хостом",
    craeteText: "Подайте заявку на создание агентства и пригласите других присоединиться"
  },
  fa: {
    dear: "کاربر گرامی",
    welcome: "به سیستم میزبان خوش آمدید، از طریق این سیستم می‌توانید پاداش نقدی مربوطه را دریافت کنید. قوانین به شرح زیر است:",
    ruleContent: `
    1: برای فعال‌سازی یک آژانس میزبان، تعداد میزبان‌های ثبت‌نام شده باید حداقل 15 میزبان باشد (تعداد می‌تواند بیشتر باشد، اما نباید کمتر باشد) <br/>
    2: پول از طریق دریافت هدایای روبی به دست می‌آید<br/>
    3: هدایای روبی منجر به الماس‌هایی می‌شوند که می‌توان آن‌ها را به سکه تبدیل کرد. میزبان همچنین می‌تواند روبی‌ها را از امتیازهای خود برداشت کرده و از آن‌ها در کیف پول روبی استفاده کند که این تأثیر بر امتیازات او دارد<br/>
    4: هدف در پایان هر ماه تکمیل می‌شود و با شروع ماه جدید، هدف جدید آغاز می‌شود. پول در تاریخ 10 هر ماه به آژانس‌ها ارسال می‌شود<br/>
    5: آژانس‌های میزبان از طریق WhatsApp برای ارسال اطلاعات مورد نیاز برای ثبت‌نام در ابتدای هر ماه دریافت می‌شوند`,
    desc1: "پاداش‌های نقدی برای حساب‌های زیر لغو خواهد شد: بازپرداخت پس از شارژ مجدد، و تقلب توسط یک کاربر که از چندین حساب جعلی استفاده می‌کند",
    desc2: "",
    tips: "اخطار",
    wait: "در انتظار بررسی",
    waitc: "لطفاً صبور باشید و هر زمان که خواستید روند درخواست را دنبال کنید",
    suc: "درخواست موفقیت‌آمیز",
    sucC: "تبریک می‌گوییم که به عضویت برنامه سیستم میزبان درآمدید. شما می‌توانید روبی‌ها را برداشت کنید.",
    fail: "درخواست ناموفق",
    failC: "متاسفیم که درخواست شما برای سیستم میزبان به دلایل زیر ناموفق بود:",
    apply: "درخواست",
    rapply: "درخواست مجدد",
    whatsapp: "واتساپ",
    areaNumber: "کد منطقه: +44",
    phomeNumber: "شماره تلفن: 7707115144",
    welcomeText: "خوش آمدید به",
    hostsystem: "سیستم میزبان",
    findanAgency: "یافتن یک آژانس",
    createanAgency: "ایجاد یک آژانس",
    findText: "یک آژانس پیدا کنید و درخواست دهید تا به عنوان میزبان بپیوندید",
    craeteText: "درخواست دهید تا یک آژانس ایجاد کنید و دیگران را دعوت کنید تا بپیوندند"
  }
}



// WEBPACK FOOTER //
// src/pages/app/newTestPic/lang.js